// Angular Imports
import { Component, EventEmitter, Input, Output } from '@angular/core'
import { NgIf } from '@angular/common'
// Angular Material Imports
import { MatButtonModule } from '@angular/material/button'
import { MatRippleModule } from '@angular/material/core'
import { MatTooltipModule } from '@angular/material/tooltip'
// This Module Imports
import { IconComponent } from '../icon/icon.component'
// Shared Imports
import { EButtonColor, EIconButtonSize, TTooltipPosition } from '@shared/models'

@Component({
	selector: 'app-icon-button',
	standalone: true,
	imports: [NgIf, MatButtonModule, MatRippleModule, MatTooltipModule, IconComponent],
	templateUrl: './icon-button.component.html',
	styleUrls: ['./icon-button.component.scss'],
})
export class IconButtonComponent {
	@Input() buttonSize: keyof typeof EIconButtonSize = EIconButtonSize.normal
	@Input() color: keyof typeof EButtonColor = EButtonColor.inherit
	@Input() hasBackground: boolean = false
	@Input() isDisabled: boolean = false
	@Input() hasTooltip: string = ''
	@Input() tooltipPosition: TTooltipPosition = 'below'
	@Output() clicked = new EventEmitter<void>()

	readonly EIconButtonSize = EIconButtonSize
	readonly EButtonColor = EButtonColor

	emitClick() {
		this.clicked.emit()
	}
}
